import { TWizardStepComponentStatic } from "../../../interfaces";
import React, { forwardRef } from "react";
import { WizardStepWelcomeView } from "../../../Student/Steps/WizardStepWelcome";

export const WizardStepWelcome: TWizardStepComponentStatic<any> = forwardRef(
  () => {
    return <WizardStepWelcomeView userType="host" />;
  }
);
